export const noop = <T>(arg: T) => (..._args: any[]): T => arg;
